export default {
  apartments: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Soluzioni',
    breadcrumbCurrent: 'Condomini e immobili',
    hero: {
      eyebrow: 'Condomini e immobili',
      title: 'Sicurezza per interi edifici residenziali',
      lead: 'Ingresso, scale, garage interrato: pianifichiamo la sorveglianza per condomini che protegge gli inquilini e dà tranquillità ai proprietari.',
    },
    areas: {
      title: 'Punti di sorveglianza nel condominio',
      lead: 'Le aree comuni sono i punti di partenza più importanti. Rispettiamo sempre i diritti di tutti i residenti.',
      items: {
        '0': { title: 'Ingresso', desc: 'L’ingresso è il biglietto da visita dell’edificio e il punto di sorveglianza più importante. Le telecamere riprendono chi entra.' },
        '1': { title: 'Scale', desc: 'Le scale sono passaggi con molto movimento. Telecamere compatte chiudono le lacune tra i piani senza farsi notare.' },
        '2': { title: 'Cantina biciclette', desc: 'Bici ed e-bike sono obiettivi comuni di furto. La sorveglianza dissuade e aiuta a chiarire.' },
        '3': { title: 'Aree esterne', desc: 'Parchi, verde e percorsi sono comuni. Telecamere resistenti proteggono anche qui.' },
        '4': { title: 'Garage interrato', desc: 'I posti del garage interrato sono a rischio di notte. La sorveglianza ben illuminata crea sicurezza.' },
        '5': { title: 'Cassette postali', desc: 'Cassette e armadietti pacchi sono centrali per i furti di pacchi. Le telecamere d’accesso aiutano molto.' },
      },
    },
    protection: {
      eyebrow: 'Privacy e regolamento',
      title: 'Sorvegliare senza violare',
      lead: 'In un condominio convivono molti interessi. Implementiamo la sorveglianza nel rispetto della privacy dei residenti e in modo legale.',
      items: {
        '0': { title: 'Mascheramento privacy', desc: 'Finestre, porte e aree private sono nascoste tecnicamente; restano solo le aree comuni.' },
        '1': { title: 'Delibera e regolamento', desc: 'La videosorveglianza in condominio richiede una base solida. Ti supportiamo nell’implementazione.' },
        '2': { title: 'Segnaletica', desc: 'Avvisi chiari all’ingresso informano inquilini e visitatori, in modo trasparente e corretto.' },
      },
    },
    value: {
      eyebrow: 'Valore aggiunto',
      title: 'Vantaggi per proprietari e amministratori',
      lead: 'Un impianto ben pensato ripaga tutti: gli inquilini si sentono più sicuri, i proprietari proteggono l’immobile e gli amministratori hanno chiarezza.',
      list: {
        '0': 'Accesso per amministratori e proprietari con diritti separati',
        '1': 'Registrazione degli ultimi giorni o settimane, secondo configurazione',
        '2': 'Sgravio per l’amministrazione in incidenti e controversie',
        '3': 'Documentazione completa in caso di vandalismo o effrazione',
        '4': 'Dissuasione di accessi non autorizzati',
        '5': 'Maggiore senso di sicurezza per inquilini e proprietari',
      },
      note: 'Nota: la liceità della videosorveglianza negli edifici residenziali dipende molto dal caso. Ti consigliamo, senza sostituire la consulenza legale.',
    },
    cta: {
      title: 'Più sicurezza per il tuo edificio',
      lead: 'Consigliamo condomini e amministratori senza impegno, dall’idea al sistema chiavi in mano.',
      primary: 'Fissa un appuntamento di consulenza',
      secondary: 'Avvia il pianificatore di telecamere',
    },
  },
};